import ScrollAnimation from "react-animate-on-scroll";
import { FiArrowRight } from "react-icons/fi";
import Logo from "../logo/Logo";

const COMPANY_NAME = 'KR Power Supports Pvt Ltd';

const callToActionData = {
    subtitle: "Since 1995 – IEC-certified manufacturer of cable trays, panels, bus ducts & solar structures. Global delivery • 24/7 support • ISO 9001:2015 certified",
    btnText: COMPANY_NAME,
};

const CalltoActionSeven = () => {
    return (
        <div className="rn-callto-action clltoaction-style-default style-7">
            <div className="container">
                <div className="row row--0 align-items-center content-wrapper">
                    <div className="col-lg-8 col-md-8">
                        <div className="inner">
                            <div className="content text-start">
                                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
                                    <Logo
                                        image={`${process.env.PUBLIC_URL}/images/logo/logos.png`}
                                    />
                                    <h2
                                        style={{
                                            fontSize: '24px',
                                            fontWeight: '700',
                                            background: 'linear-gradient(to right, #008000, #800000)',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                            margin: 0,
                                            fontFamily: 'Montserrat, sans-serif'
                                        }}
                                    >
                                        {COMPANY_NAME}
                                    </h2>
                                </div>
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                    <p className="subtitle">{callToActionData.subtitle}</p>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4">
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                            <div className="call-to-btn text-start mt_sm--20 text-md-end">
                                <a className="btn-default btn-icon" target="_blank" href="/contact" rel="noopener noreferrer">{callToActionData.btnText} <i className="icon"><FiArrowRight /></i></a>
                            </div>
                        </ScrollAnimation>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CalltoActionSeven;
